export const FETCH_THEME_REQUEST       = 'theme/fetch/request';
export const FETCH_THEME_SUCCESS       = 'theme/fetch/success';
export const FETCH_THEME_FAIL          = 'theme/fetch/fail';
